import clsx from 'clsx'
import { ThemeModeSwitcher } from '../../../partials'
import { useAuth } from '../../../../app/modules/auth/core/Auth'

const itemClass = 'ms-1 ms-lg-3'

const Navbar = () => {
  const { logout } = useAuth()
  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div className='menu-item px-5'>
          <a onClick={logout} className='menu-link px-5'>
            Cerrar Sesión
          </a>
        </div>
      </div>
    </div>
  )
}

export { Navbar }